import { render, staticRenderFns } from "./TableRevisionsList.vue?vue&type=template&id=45587a3e&scoped=true"
import script from "./TableRevisionsList.vue?vue&type=script&lang=js"
export * from "./TableRevisionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45587a3e",
  null
  
)

export default component.exports